export enum SeasonQueryEnum {
  MainSeasonListUpComing = "MainSeasonListUpComing",
  MainSeasonListPast = "MainSeasonListPast",
  MainSeasonListCancelled = "MainSeasonListCancelled",
  DashboardUpComingSeasons = "DashboardUpComingSeasons",
}
